import { __zcAsy, __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for individual resource detail pages.
 */
export const ResourceDetailsPayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: safeOptional(z.array(BreadcrumbSchema)),
    indexPath: z.string().optional(),
  }),
);
var __rf=[__zs._zod.innerType.shape["breadcrumbLinks"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_10=__rf[0];
function __vb_3(input){var __bv_4,__bv_5,__bs_6,__bv_7,__bv_8,__bx_9,__bw_11,__bo_12;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_4=input["userLoggedIn"];if(!((__bv_4===undefined||(typeof __bv_4==="boolean"))))return __bf_2;__bv_5=input["contentfulRawJsonResponse"];if(!(typeof __bv_5==="object"&&__bv_5!==null&&!Array.isArray(__bv_5)))return __bf_2;__bs_6=__zcPs(__bv_5);__bv_7=input["indexPath"];if(!((__bv_7===undefined||(typeof __bv_7==="string"))))return __bf_2;__bv_8=input["breadcrumbLinks"];if(__bv_8===undefined){__bw_11=undefined;}else{__bx_9=__rfn_10(__bv_8);if(__bx_9 instanceof Promise)__zcAsy();__bw_11=__bx_9;}__bo_12={"contentfulRawJsonResponse":__bs_6};if(__bv_4!==undefined||("userLoggedIn" in input)){__bo_12["userLoggedIn"]=__bv_4;}if(__bw_11!==undefined||("breadcrumbLinks" in input)){__bo_12["breadcrumbLinks"]=__bw_11;}if(__bv_7!==undefined||("indexPath" in input)){__bo_12["indexPath"]=__bv_7;}return __bo_12;}
var __rfm_z=__zs.safeParse;
function safeParse_ResourceDetailsPayloadSchema(input){
var __bd_13=__vb_3(input);
if(__bd_13!==__bf_2){return{success:true,data:__bd_13};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_ResourceDetailsPayloadSchema,__zs,null,null);
})()

export type ResourceDetailsPayload = z.infer<typeof ResourceDetailsPayloadSchema>

export function toResourceDetailsPayload(payload: unknown): ResourceDetailsPayload {
  return ResourceDetailsPayloadSchema.parse(payload)
}
